module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f00iv-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RONTLINE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS")]), _vm._v(", L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONDON")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ace of the Black Cross")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("This edition published in 2013 by Frontline Books, an imprint of Pen & Sword Books Limited, 47 Church Street, Barnsley, S. Yorkshire, S70 2AS")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "href": "http://www.frontline-books.com",
      "target": "_blank"
    }
  }, [_vm._v("www.frontline-books.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Copyright © Ernst Udet, 1935")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Introduction © Frontline Books, 2013, 2020, 2021")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("The right of Ernst Udet to be identified as the author of this work has been asserted by him in accordance with the Copyright, Designs and Patents Act of 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("ISBN: 978 1 52678 172 7")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("eISBN: 978 1 52677 194 0")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("MOBI: 978 1 52677 194 0")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Publishing History")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("First published in German under the title "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mein Fliegerleben")]), _vm._v(" by Ullstein, Berlin, in 1935. First published in English as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ace of the Black Cross")]), _vm._v(" by Newnes, London, in 1937. Translation by Kenneth Kirkness. This edition, published by Frontline Books, London, in 2013, contains a new introduction by Richard Overy.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in or introduced into a retrieval system, or transmitted, in any form, or by any means (electronic, mechanical, photocopying, recording or otherwise) without the prior written permission of the publisher. Any person who does any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("CIP data records for this title are available from the British Library For more information on our books, please visit")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "href": "http://www.frontline-books.com",
      "target": "_blank"
    }
  }, [_vm._v("www.frontline-books.com")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("email "), _c('a', {
    attrs: {
      "href": "mailto:info@frontline-books.com"
    }
  }, [_vm._v("info@frontline-books.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("or write to us at the above address.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04983aad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Copyright.vue
// module id = 66
// module chunks = 0